import { NavLink as RouterLink } from 'react-router-dom';
import React from 'react';
// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

interface NavSectionProps {
  data: any[],
};

export default function NavSection(props: NavSectionProps) {
	return (
		<Box>
			<List disablePadding sx={{ p: 1 }}>
				{props.data.map((item) => (
					<NavItem key={item.title} item={item} />
				))}
			</List>
		</Box>
	);
}

// ----------------------------------------------------------------------

interface NavItemProps {
	item: {
    title: string;
    path: string;
    icon: string;
    info: string;
  },
};

function NavItem(props: NavItemProps) {
	const { title, path, icon, info } = props.item;

	return (
		<StyledNavItem
			component={RouterLink}
			to={path}
			sx={{
				'&.active': {
					color: 'text.primary',
					bgcolor: 'action.selected',
					fontWeight: 'fontWeightBold',
				},
			}}
		>
			<StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

			<ListItemText disableTypography primary={title} />

			{info && info}
		</StyledNavItem>
	);
}
